<template lang="pug">
	modal(:max-width="400")
		.card.text-left
			.card-header.bg-warning.text-dark
				span.fa.fa-braille.mr-2
				| Bloque publicitario
				button.close(@click="cerrar") &times;
			.card-body
				.alert.alert-info
					| Tan solo podrás editar el intérvalo de tiempo de este bloque en este día.
					| No podrás moverlo de día, para ello deberás editar bloques en masa o generar nuevos
			.card-body
				.form-group
					label Horario
					.input-group
						.input-group-prepend
							.input-group-text De
						input.form-control(placeholder="##:##:###", v-mask="'##:##:##'", v-model="bloque.hora_inicio")
						.input-group-append
							.input-group-text a
						input.input-group-append.form-control(placeholder="##:##:###", v-mask="'##:##:##'", v-model="bloque.hora_fin")
			.card-footer
				button.btn.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
</template>

<script>
export default {
	props: ['bloque'],
	methods: {
		guardar () {
			this.$http.post('gestion-emisoras/php/api/bloques/set-bloque.php', this.bloque)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Cambios guardados',
						mensaje: 'Se ha actualizado el bloque correctamente'
					})
					this.$emit('guardado')
					this.cerrar()
				})
				.catch(this.$responseError)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/bloques/editor-bloque.vue